module.exports = __webpack_public_path__ + "img/2.284836c4.png";